import Model from "../Model";

class KpiclientrepresentantZone extends Model{

    buildUrl ({ param }) {
        return ['kpiemployeeclientview/getbyzone', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiclientrepresentantZone;